import React, { useState, useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import "./Login.css";
import Navbar from "./Navbar.js";
import { useLocation } from "react-router-dom";
import Footer from "./Footer.js";
import HomeScreen from "./HomeScreen.js";
import Login from "./Login.js";

export default function MainScreen({ OnSuccess }) {
  const [showHomeScreen, setShowHomeScreen] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setShowHomeScreen(
      location.pathname === "/login" || location.pathname === "/signup"
        ? false
        : true
    );
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen w-[100vw]  WholeLoginPage">
      <Navbar />
      <main className="flex-1 mt-12 pt-12">
        {showHomeScreen ? <HomeScreen /> : <Login OnSuccess={OnSuccess} />}
      </main>
      <Footer />
    </div>
  );
}
